import styles from '../../pages/Home/Home.module.css';
import '../../App.css';
import arrow from '../../images/down_arrow.svg';
import { useState } from 'react';
import callicon from '../../images/call.svg'
import brline from '../../images/brline.svg'


function Homesection() {
    const [openSections, setOpenSections] = useState([false, false, false, false]);

    const toggleSection = (index) => {
        setOpenSections(prevState => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };

    return (
        <div>
            <div className={`${styles.w840} ${styles.pt212}`}>
                <div className={styles.textcontainer}>
                    <h1 className={`${styles.dttit}`}>Get your dream Business website that reflects your Brand vision</h1>
                    <span className={`${styles.cornersquare} ${styles.topleft}`}></span>
                    <span className={`${styles.cornersquare} ${styles.topright}`}></span>
                    <span className={`${styles.cornersquare} ${styles.bottomleft}`}></span>
                    <span className={`${styles.cornersquare} ${styles.bottomright}`}></span>
                </div>
                <p className={styles.dttxt}> Let us create a beautiful, well-designed, high-performing, and engaging website that will help you achieve your business goals</p>
                <div className={`${styles.btnpt} d-inline-block align-center`}>
                    <div className={styles.border}></div>
                    <div className={`${styles.bglinediv}`}>
                        <button className={`${styles.btntxt} d-flex gap-8 align-center justify-center`}>
                            <img src={callicon} alt='callicon' />Book a call
                        </button>
                    </div>
                </div>
            </div>

            <div className={`${styles.offtxt} pt-108`} id='solutions'>
                <h2 className='text-center'>What do we <span>Offer</span></h2>
                
                <div className={`${styles.w1080} ${styles.flexmob} ${styles.p32} ${styles.pb40} d-flex justify-space-between gap-40`}>
                    <div className={`${styles.card} d-flex justify-space-between align-center gap-40`}>
                        <div>
                            <h2 className={styles.anisub}>
                                We build Stunning websites from Scratch
                            </h2>
                            <p className={styles.subp} style={{ display: openSections[0] ? 'block' : 'none' }}>
                                Whether you need a complete brand identity or just a refresh...
                            </p>
                        </div>
                        <div className={styles.arrow} onClick={() => toggleSection(0)}>
                            <img src={arrow} alt='downarrow' />
                        </div>
                    </div>

                    <div className={`${styles.card} d-flex justify-space-between align-center gap-40`}>
                        <div>
                            <h2 className={styles.anisub}>
                                Graphic design & Branding
                            </h2>
                            <p className={styles.subp} style={{ display: openSections[1] ? 'block' : 'none' }}>
                                Whether you need a complete brand identity or just a refresh, we'll collaborate closely with you to understand your values and aspirations. From concept to execution, we'll design everything from logos, business cards to brochures & social media graphics that resonate with your audience.
                            </p>
                        </div>
                        <div className={styles.arrow} onClick={() => toggleSection(1)}>
                            <img src={arrow} alt='downarrow' />
                        </div>
                    </div>
                    
                </div>

                <div className={`${styles.w1080} ${styles.flexmob} ${styles.p32} d-flex justify-space-between gap-40`}>
                    <div className={`${styles.card} d-flex justify-space-between align-center gap-40`}>
                        <div>
                            <h2 className={styles.anisub}>
                                Revamp your existing website
                            </h2>
                            <p className={styles.subp} style={{ display: openSections[2] ? 'block' : 'none' }}>
                            Experiencing lots of bugs & poor website design? Looking for a solution to fix your website problems? We will help you redesign & fix your website design (UI), Bugs, or any technical problem to match your exact vision.
                            </p>
                        </div>
                        <div className={styles.arrow} onClick={() => toggleSection(2)}>
                            <img src={arrow} alt='downarrow' />
                        </div>
                    </div>

                    <div className={`${styles.card} d-flex justify-space-between align-center gap-40`}>
                        <div>
                            <h2 className={styles.anisub}>
                                Digital Marketing service (Exclusive)
                            </h2>
                            <p className={styles.subp} style={{ display: openSections[3] ? 'block' : 'none' }}>
                                Whether you need a complete brand identity or just a refresh...
                            </p>
                        </div>
                        <div className={styles.arrow} onClick={() => toggleSection(3)}>
                            <img src={arrow} alt='downarrow' />
                        </div>
                    </div>
                    
                </div>


            </div>

            <div className={`${styles.offtxt} pt-108`}>
                <h2 className='text-center'><span>Problems</span> with Other <br/>Website Agencies</h2>
                <div className={styles.tablecontainer}>
                    <table>
                        <tr>
                            <td>Poor website design</td>
                            <td>Poor customer support</td>
                        </tr>
                        <tr>
                            <td>Duplicated themes</td>
                            <td>No UX/UI designed</td>
                        </tr>
                        <tr>
                            <td>Fake testimonials</td>
                            <td>No personalized design</td>
                        </tr>
                        <tr>
                            <td>Lack of control over your website</td>
                            <td>Delayed delivery</td>
                        </tr>
                        <tr>
                            <td>Expensive</td>
                            <td>No Proper Communication</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div className={`${styles.subtxt} ${styles.w1080} pt-108`}>
                <h2>How do we <span>solve</span> these problems?</h2>
                <div className={`${styles.dtpb} d-grid justify-center`}>
                    <p>Dedicated support.</p>
                    <p>Customizable themes.</p>
                    <p>Search engine optimized.</p>
                    <p>Personalized support.</p>
                    <p>Complete control over your website</p>
                    <p>No copyright issues - Custom UX/UI designed website</p>
                    <p>Flexible service</p>
                </div>
            </div>

            <div className={`${styles.subtxt} ${styles.w1080} pt-108`}>
                <h2>Why We are<span> Successful?</span></h2>
                <div className={`${styles.p32} ${styles.flexmob} d-flex justify-center gap-40`}>
                    <div className={styles.dtsuccess}>
                        <span>Focused Approach:  </span>
                        <p>We only handle one project at a time</p>
                    </div>
                    <div className={styles.dtsuccess}>
                        <span>Methodical Work:  </span>
                        <p>We never rush, this disciplined approach helps us in delivering quality results.</p>
                    </div>
                </div>
                <div className={`${styles.p32} ${styles.flexmob} d-flex justify-center gap-40 mt-40`}>
                    <div className={styles.dtsuccess}>
                        <span>Seamless Collaboration:  </span>
                        <p>We work closely with clients to understand and meet their expectations.</p>
                    </div>
                    <div className={styles.dtsuccess}>
                        <span>Expert Team:   </span>
                        <p>Our skilled professionals work diligently to achieve outstanding results.</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.subtxt} ${styles.w1080} pt-108`} id='process'>
                <h2>Our<span> Process</span></h2>
                <div className='text-center'>
                    <p className={styles.dtpb}>We strictly follow this work flow to make sure we deliver 100% quality results.</p>
                </div>
                <div className={styles.container}>
                    <div className={styles.stage}>
                        <span className={styles.stagenumber}>1</span>
                            <div>
                            <p className={styles.dtptag}>Consultation</p>
                            <p className={styles.dtspan}>Virtual meeting</p>
                            </div>
                    </div>
                    <div className={styles.stage}>
                        <span className={styles.stagenumber}>2</span>
                        <div>
                        <p className={styles.dtptag}>Design</p>
                        <p className={styles.dtspan}>UX/UI designer will start your design</p>
                        </div>
                    </div>
                    <div className={styles.stage}>
                        <span className={styles.stagenumber}>3</span>
                        <div>
                        <p className={styles.dtptag}>Development</p>
                        <p className={styles.dtspan}>Website Development</p>
                        </div>
                    </div>
                    <div className={styles.stage}>
                        <span className={styles.stagenumber}>4</span>
                        <div>
                        <p className={styles.dtptag}>Testing & Review</p>
                        <p className={styles.dtspan}>Website review & correction </p>
                        </div>
                    </div>
                    <div className={styles.stage}>
                        <span className={styles.stagenumber}>5</span>
                        <div>
                        <p className={styles.dtptag}>Launch</p>
                        <p className={styles.dtspan}>Site Launch (Start your sales)</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${styles.subtxt} ${styles.w1080} pt-108`}>
                <h2><span>Privilege</span> of choosing us</h2>
                <div className='text-center'>
                    <p className={styles.dtpb}>Unlock the Power of Automation - Save ₹2000 <br/>with Our Complimentary setup of Industry-Standard Tools to <br/>Streamline Your Business.</p>
                </div>
            </div>

            <div className={`${styles.subtxt} ${styles.w1080}  pt-108 pb-108`}>
                <h2><span>Ready to Stand out</span> of the Crowd</h2>
                <div className='text-center'>
                    <p className={styles.dtpb}>Why should you have the same website design as your competitors? Let<br className='br'/> us create & build your unique business website that engages & converts<br className='br'/> more sales</p>
                </div>
                <div className={`text-center`}>
                <div className={`${styles.btnpt} d-inline-block align-center`}>
                    <div className={`${styles.bglinediv}`}>
                        <button className={`${styles.btntxt} d-flex gap-8 align-center justify-center`}>
                            <img src={callicon} alt='callicon' />Book a call
                        </button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}

export default Homesection;
